import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=30eec68e&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"
import style0 from "./FaqView.vue?vue&type=style&index=0&id=30eec68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eec68e",
  null
  
)

export default component.exports